var SBus = {
            selectedProvider:null,
			sBusDepartureResultTable:null,
			sBusReturnResultTable:null,
			message:{
				selectFare:FmtMessage.getMessage('js.sbus.select.fare')			
			},
			adultCount:null,
			childCount:0,
			pressCount:0,
			disabilityCount:0,
			veteranCount:0,
			studentCount:0,
			elderlyCount:0,
			vadultCount:null,
			vchildCount:0
		};

$(document).ready(function() {
	sbusSearch.init();
	sBusSearchFilter.init();
	
	if(SBus.adultCount){
		$('#adultCount').val(SBus.adultCount);
		$('#childCount').val(SBus.childCount);
		$('#pressCount').val(SBus.pressCount);
		$('#disabilityCount').val(SBus.disabilityCount);
		$('#veteranCount').val(SBus.veteranCount);
		$('#studentCount').val(SBus.studentCount);
		$('#elderlyCount').val(SBus.elderlyCount);
		
		$('#adultCount').change();
		$('#childCount').change();
		$('#pressCount').change();
		$('#disabilityCount').change();
		$('#veteranCount').change();
		$('#studentCount').change();
		$('#elderlyCount').change();
	} else if($.cookie('numAdultSBus')){
		$('#adultCount').val($.cookie('numAdultSBus'));
		$('#childCount').val($.cookie('numChildSBus'));
		$('#pressCount').val($.cookie('numPressSBus'));
		$('#disabilityCount').val($.cookie('numDisabilitySBus'));
		$('#veteranCount').val($.cookie('numVeteranSBus'));
		$('#studentCount').val($.cookie('numStudentSBus'));
		$('#elderlyCount').val($.cookie('numElderlySBus'));
		
		$('#adultCount').change();
		$('#childCount').change();
		$('#pressCount').change();
		$('#disabilityCount').change();
		$('#veteranCount').change();
		$('#studentCount').change();
		$('#elderlyCount').change();
	} else {
		$('#adultCount').val("1");
		$('#childCount').val("0");
		$('#pressCount').val("0");
		$('#disabilityCount').val("0");
		$('#veteranCount').val("0");
		$('#studentCount').val("0");
		$('#elderlyCount').val("0");
	}
	
	if(SBus.vadultCount){
		$('#vadultCount').val(SBus.vadultCount);
		$('#vchildCount').val(SBus.vchildCount);
		
		$('#vadultCount').change();
		$('#vchildCount').change();
	} else if($.cookie('numVAdultSBus')){
		$('#vadultCount').val($.cookie('numVAdultSBus'));
		$('#vchildCount').val($.cookie('numVChildSBus'));
		
		$('#vadultCount').change();
		$('#vchildCount').change();
	} else {
		$('#vadultCount').val("0");
		$('#vchildCount').val("0");
	}

    var alertShownOnload = false;
	var alertAvailable = false;

	$(".travelerSelectPax").change(function () {
        var adultCount = parseInt($("#adultCount").val());
        var childCount = parseInt($("#childCount").val());

        if (SBus.selectedProvider == "BUDO" && (getValueOrDefault(adultCount, 0) < getValueOrDefault(childCount, 0)) && (!alertShownOnload || alertAvailable == true))
            alert(FmtMessage.getMessage('js.alert.sbus.child.discount'));
        alertShownOnload = true;
    });

	$("#adultCount, #childCount, #pressCount, #disabilityCount, #veteranCount, #studentCount, #elderlyCount").change(function(){
		  var adultCount = parseInt($( "#adultCount" ).val());
		  var childCount = parseInt($( "#childCount" ).val());
		  var pressCount = parseInt($( "#pressCount" ).val());
		  var disabilityCount = parseInt($( "#disabilityCount" ).val());
		  var veteranCount = parseInt($( "#veteranCount" ).val());
		  var studentCount = parseInt($( "#studentCount" ).val());
		  var elderlyCount = parseInt($( "#elderlyCount" ).val());
		  try {
			$.cookie('numAdultSBus', adultCount, { expires : 365, path : '/' });
			$.cookie('numChildSBus', childCount, { expires : 365, path : '/' });
		   	$.cookie('numPressSBus', pressCount, { expires : 365, path : '/' });
		   	$.cookie('numDisabilitySBus', disabilityCount, { expires : 365, path : '/' });
		   	$.cookie('numVeteranSBus', veteranCount, { expires : 365, path : '/' });
		   	$.cookie('numStudentSBus', studentCount, { expires : 365, path : '/' });
		   	$.cookie('numElderlySBus', elderlyCount, { expires : 365, path : '/' });
		  } catch (e) {
		  }
		  
		  if (SBus.selectedProvider=="BUDO" || (SBus.selectedProvider=="IDO"&&$('input[name="sbusVehicle"]:checked').val() == 0)) {
              var totalPax = getValueOrDefault(adultCount, 0) + getValueOrDefault(childCount, 0) + getValueOrDefault(pressCount, 0) + getValueOrDefault(disabilityCount, 0) + getValueOrDefault(veteranCount, 0) + getValueOrDefault(studentCount, 0) + getValueOrDefault(elderlyCount, 0);

              $(".travelerSelectPax").html(totalPax).trigger("change");

			  var locale = $.cookie('siteLocale');

			  if(locale == "en"){
				  if(totalPax > 1){
				  	$(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.travelers'));
				  }else{
				  	$(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler'));
				  }
			  }else if(locale == "ru" || locale == "uk"){
				  var partLast2 = totalPax % 100;
				  var partLast1 = totalPax % 10;
				  if(partLast1 == 0 || (partLast1 >= 5 && partLast1 <= 9) || (partLast2 >= 11 && partLast2 <= 14)){
					  $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler.ru3'));
				  }else if(partLast1 == 1){
					  $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler.ru1'));
				  }else if(partLast1 >= 2 && partLast1 <= 4){
					  $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler.ru2'));
				  }
			  }else{
				  $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler'));
			  }
		  }
	}).trigger('change');

	alertAvailable = true;

	function getValueOrDefault(valueToCheck, defaultValue){
	   return valueToCheck=valueToCheck||defaultValue;
    }
	
	
	$("#vadultCount, #vchildCount").change(function(){
		  var vadultCount = parseInt($( "#vadultCount" ).val());
		  var vchildCount = parseInt($( "#vchildCount" ).val());
		  
		  try {
			$.cookie('numVAdultSBus', vadultCount, { expires : 365, path : '/' });
			$.cookie('numVChildSBus', vchildCount, { expires : 365, path : '/' });
		  } catch (e) {
		  }
		  if ($('input[name="sbusVehicle"]:checked').val() == 1) {
		  var totalPax = vadultCount + vchildCount ;
		  $(".travelerSelectPax").html(totalPax).trigger("change");
		  var locale = $.cookie('siteLocale');
		  if(locale == "en"){
			  if(totalPax > 1){
			  	$(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.travelers'));
			  }else{
			  	$(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler'));
			  }
		  }else if(locale == "ru" || locale == "uk"){
			  var partLast2 = totalPax % 100;
			  var partLast1 = totalPax % 10;
			  if(partLast1 == 0 || (partLast1 >= 5 && partLast1 <= 9) || (partLast2 >= 11 && partLast2 <= 14)){
				  $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler.ru3'));
			  }else if(partLast1 == 1){
				  $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler.ru1'));
			  }else if(partLast1 >= 2 && partLast1 <= 4){
				  $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler.ru2'));
			  }
		  }else{
			  $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler'));
		  }
		  }
	}).trigger('change');
	

	$(".travelerSelect").click(function() {
		$('.selectPersonList').toggle("fade","fast");
		return false;
	});
	$('body').click(function(event) {
		if (!$(event.target).closest('.selectPersonList').length) {
			$('.selectPersonList').hide();
		};
	});	
	$(".pop-close-btn").click(function() {
		$('.selectPersonList').hide();
		return false;
	});
	
});	